import React from "react";
import { BackHandler, StyleSheet, View } from "react-native";
import { connect } from "react-redux";
import Text from "@components/AppText";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import { actions } from "@reducers/orderReducer";
import RatingView from "./RatingView";

import t from "../constants/localization";

const PATH = "components/RateOrderScreen";

export const RatingMapping = {
  1: t(`${PATH}/1`),
  2: t(`${PATH}/2`),
  3: t(`${PATH}/3`),
  4: t(`${PATH}/4`),
  5: t(`${PATH}/5`),
};

const RatingHeader = ({ navigation, route }) => {
  return (
    <HeaderWithBackAndTitle
      headertitle={t(`${PATH}/rateUs`) || ""}
      headerColor="#fff"
      hideShadow={false}
      navigation={navigation}
      route={route}
    />
  );
};

const RateOrderScreen = (props) => {
  const { navigation, route } = props;
  const {
    for_order = false,
    rating_cl = 0,
    review_cl = [],
    order_id = "",
    refresh = () => {},
    expected_commission = "",
    delivered_at = new Date().toISOString(),
    modal = false,
  } = route.params;

  React.useEffect(() => {
    const onBackPress = () => {
      return modal;
    };
    const subscription = BackHandler.addEventListener("hardwareBackPress", onBackPress);
    return () => subscription.remove();
  });

  const viewProps = {
    for_order,
    rating_cl,
    review_cl,
    order_id,
    refresh,
    expected_commission,
    delivered_at,
  };

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: "#f7f7f7",
      }}
    >
      {!modal && <RatingHeader route={route} navigation={navigation} />}
      {modal && (
        <Text bold fontType="head1" style={styles.textHeading}>
          {t(`${PATH}/rateUs`)}
        </Text>
      )}
      <RatingView {...viewProps} navigation={navigation} />
    </View>
  );
};

const styles = StyleSheet.create({
  dialog: {
    padding: 16,
    backgroundColor: "#fff",
    borderRadius: 5,
    elevation: 6,
    width: "85%",
  },
  textHeading: {
    textAlign: "center",
    fontSize: 18,
    marginTop: 38,
    marginBottom: 34,
    color: "rgba(0, 0, 0, 0.86)",
  },
});

const mstp = ({ wallet, auth: { user } }) => {
  return {
    wallet,
    user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllOrders: (payload) => dispatch(actions.getAllOrdersReq(payload)),
  };
};

export default connect(mstp, mapDispatchToProps)(RateOrderScreen);
